import Sidebar from '../components/Sidebar';
import { useSkyContext } from '../store/provider';
import SnackbarUi from '../components/common/Snackbar';
import AuthProvider from './AuthProvider';
import Header from '../components/Header';

const bgImage = require('../assets/bg.png');

const MainLayout: React.FC<{ children: JSX.Element | JSX.Element[] }> = ({
  children,
}) => {
  const skyContext = useSkyContext();
  const isAuthenticated = skyContext.isAuthenticated;

  return (
    <AuthProvider>
      <div>
        <Sidebar />
        <div className={`${(isAuthenticated && 'sidebar-space') || ''}`}>
          <Header />
          <div>{children}</div>
        </div>
        <SnackbarUi />
      </div>
    </AuthProvider>
  );
};

export default MainLayout;
